import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse, SiteStatsData } from 'src/common/interfaces';
export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getSiteStats: builder.query<ApiResponse<SiteStatsData>, null>({
      query: () => ({
        url: `/site-stats`,
        method: 'GET'
      })
    })
  })
});
export const {
  useGetSiteStatsQuery
} = extendedApiSlice;